import React, { useState, useEffect } from "react";
import { useDispatch } from "react-redux";
import { Routes, Route } from "react-router-dom";

//COMPONENTS
import Controller from "./files/controller";

function PodRouter() {
    const [loaded, setLoaded] = useState(false);

    useEffect(() => {
        setLoaded(true);
    }, []);

    return (
        <div>
            {loaded && (
                <div>
                    <Routes>
                        <Route path="/" element={<Controller />} />
                    </Routes>
                </div>
            )}
        </div>
    );
}

export default PodRouter;
